import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Counter } from '../../shared/models/counter.model';
import { environment } from 'src/environments/environment';
import { map, catchError } from 'rxjs/operators';
import { throwError, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CounterService {

  private _counter: Counter = new Counter();

  public onCounterChange: Subject<void> = new Subject();
  public get counter(): Counter {
    return { ...this._counter };
  }

  constructor(private _http: HttpClient) { }

  /**
   * increase or decrease the counter value
   */
  public changeCounterValue() {

  }

  /**
   * getCounterInformations
   */
  public getCounterInformations(organizationId: string) {
    let paramas = new HttpParams();
    paramas = paramas.append('organizationId', organizationId);
    return this._http.get<Counter>(environment.serverUrl + 'counter/getInformations', {
      params: paramas,
    }).pipe(
      map(responseData => {
        this._counter = responseData;
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public setCounterValue(value: number, organizationId: string): void {
    this._http
      .post<{
        appValue: number,
        currentPeople: number,
        updatedAt: string
      }>(
        environment.serverUrl + 'counter/set',
        {
          'id': organizationId,
          'value': value
        }
      ).subscribe((responseData) => {
        if (this._counter.currentPeopleAmount >= 0 && (this._counter.closed === 1 || this._counter.closed === null)) {
          this._counter.closed = 0;
        }
        this._counter.currentPeopleAmount = responseData.currentPeople;
        this.onCounterChange.next();
      });
  }

  public setCurrentPeopleValue(value: number, organizationId: string): void {
    this._http
      .post<{
        currentPeople: number,
        updatedAt: string
      }>(
        environment.serverUrl + 'counter/currentPeople',
        {
          'id': organizationId,
          'value': value
        }
      ).subscribe((responseData) => {
        if (this._counter.currentPeopleAmount === 0 && this._counter.closed === 1) {
          this._counter.closed = 0;
        }
        this._counter.currentPeopleAmount = responseData.currentPeople;
        this.onCounterChange.next();
      });
  }

  public setMaxPeopleValue(value: number, organizationId: string): void {
    this._http
      .post<void>(
        environment.serverUrl + 'counter/maxPeople',
        {
          'id': organizationId,
          'value': value
        }
      ).subscribe(() => {
        this._counter.maxAllowedPersons = value;
        this.onCounterChange.next();
      });
  }

  public setClosed(status: number, organizationId: string): void {
    this._http
      .post<void>(
        environment.serverUrl + 'counter/setClosed',
        {
          'id': organizationId,
          status
        }
      ).subscribe(() => {
        this._counter.closed = status;
        this.onCounterChange.next();
      });
  }

  public setBlocked(blocked: number, organizationId: string): void {
    this._http
      .post<void>(
        environment.serverUrl + 'counter/setBlocked',
        {
          'id': organizationId,
          'blocked': blocked
        }
      ).subscribe(() => {
      this._counter.blocked = blocked;
      this.onCounterChange.next();
    });
  }
}
